export const SNAPSHOT_KEYS = ["formData", "stagedAttachments", "selectedTransaction", "selectedPickUpTransactionItems", "selectedPickUpTransaction", "pickUpData", "otherDetailsData"];
const ENTRY_KEYS = ["transactionCode", "backDatedEntry", "pickupMandatory", "isAutoTransactionNo", "colorCode", "customerType", "dynamicHeadData", "dynamicItemData", "dynamicTransaction", "sourceTranCode", "sourceTranId", "sourceCategory"];
const forbidden = /^(?:__proto__|constructor|prototype|authorization|password|token|access_token|refresh_token|session_id|sessionId)$/i;

export function serializable(value) {
  if (value === null || typeof value === "string" || typeof value === "boolean") return value;
  if (typeof value === "number") return Number.isFinite(value) ? value : null;
  if (value instanceof Date) return value.toISOString();
  if (Array.isArray(value)) return value.map(serializable).filter((v) => v !== undefined);
  if (value && Object.getPrototypeOf(value) === Object.prototype) {
    return Object.fromEntries(Object.entries(value).filter(([key]) => !forbidden.test(key))
      .map(([key, item]) => [key, serializable(item)]).filter(([, item]) => item !== undefined));
  }
  return undefined;
}
export function snapshotStore(state) {
  const snapshot = Object.fromEntries(SNAPSHOT_KEYS.map((key) => [key, serializable(state[key])]));
  snapshot.stagedAttachments = (state.stagedAttachments || []).filter((a) => a.id != null || a.attachment_id != null)
    .map((a) => Object.fromEntries(["id", "attachment_id", "scope", "fieldName", "field_name", "rowIndex", "name", "file_name", "url", "file_url", "s3_url", "mime_type", "size"].filter((key) => a[key] !== undefined).map((key) => [key, serializable(a[key])])));
  return snapshot;
}
export function validDraftPath(path) {
  return typeof path === "string" && /^\/[a-zA-Z0-9_-]+\/[a-zA-Z0-9_-]+\/transactions$/.test(path) && !path.startsWith("/master/");
}
export function eligibleEntry(state, path) {
  return validDraftPath(path) && typeof state?.transactionCode === "string" && /^[A-Za-z0-9_]{1,31}$/.test(state.transactionCode) && !state.transactionId &&
    !state.isEditMode && !state.isCopyMode && !(state.rowData && !state.isAddMode) &&
    state.transactionSettings?.type !== "master" && !["JC", "BOM", "WBOM", "PL", "CM", "VM", "PM", "DR"].includes(state.transactionCode.toUpperCase()) &&
    !/\/(drawing-status|dr)\//.test(path);
}
export function entrySnapshot(state, path) {
  return { path, ...Object.fromEntries(ENTRY_KEYS.filter((key) => state[key] !== undefined).map((key) => [key, serializable(state[key])])), isAddMode: true };
}
export function validateDraft(draft, expectedCode, expectedPath) {
  const entry = draft?.payload?.entry;
  const snapshot = draft?.payload?.snapshot;
  if (!draft?.id || draft.submitted_tran_id || draft.schema_version !== 1 || draft.form_kind !== "transaction" ||
      !entry || !eligibleEntry(entry, entry.path) || entry.transactionCode !== draft.transaction_code ||
      (expectedCode && expectedCode !== draft.transaction_code) || (expectedPath && expectedPath !== entry.path) ||
      !snapshot?.formData || !snapshot.formData.primaryDetails || !snapshot.formData.customerDetails ||
      !Array.isArray(snapshot.formData.transactionItems) || !Array.isArray(snapshot.stagedAttachments) ||
      !Array.isArray(snapshot.selectedPickUpTransactionItems) || !Array.isArray(snapshot.otherDetailsData) ||
      !snapshot.selectedTransaction || !snapshot.selectedPickUpTransaction || !snapshot.pickUpData ||
      !Number.isInteger(draft.revision)) {
    throw new Error("This draft cannot be restored as a new transaction.");
  }
  return { entry: entrySnapshot(entry, entry.path), snapshot: snapshotStore(snapshot) };
}